import { PromotedTaxon } from 'types';
import { i18nStore } from '../../contexts/i18n';
import { nanoid } from 'nanoid';

export const buildEmptyPromotedTaxon = () => {
  return {
    h1Text: '',
    h1TextPosition: 'left',
    h3Text: '',
    h3TextPosition: 'left',
    permalink: `/${nanoid()}`,
    imageUrl:
      'data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgPGRlZnM+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImciPgogICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjY2JjYmNiIiBvZmZzZXQ9IjIwJSIgLz4KICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI2Y5ZjlmOSIgb2Zmc2V0PSI1MCUiIC8+CiAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNjYmNiY2IiIG9mZnNldD0iNzAlIiAvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3Qgd2lkdGg9IjcwMCIgaGVpZ2h0PSI0NzUiIGZpbGw9IiNjYmNiY2IiIC8+CiAgPHJlY3QgaWQ9InIiIHdpZHRoPSI3MDAiIGhlaWdodD0iNDc1IiBmaWxsPSJ1cmwoI2cpIiAvPgogIDxhbmltYXRlIHhsaW5rOmhyZWY9IiNyIiBhdHRyaWJ1dGVOYW1lPSJ4IiBmcm9tPSItNzAwIiB0bz0iNzAwIiBkdXI9IjFzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgIC8+Cjwvc3ZnPg==',
  } as PromotedTaxon;
};

export const buildEmptyPromotedTaxons = () => {
  return [buildEmptyPromotedTaxon(), buildEmptyPromotedTaxon()];
};

export const i18nCategoryName = (
  i18n: i18nStore,
  h3Text?: string,
  h1Text?: string
) => {
  if (h3Text) return i18n[h3Text] ?? h3Text;
  if (h1Text) return i18n[h1Text] ?? h1Text;
};
